import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { SENTRY_DSN } from './config';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Sentry BEFORE React renders (captures errors from first render)
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // Errors only — no performance tracing to keep overhead minimal
    tracesSampleRate: 0,
    sampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
